import React, { useState, useEffect } from "react";
import { Table, Button, Pagination, Col, Row } from "react-bootstrap";
import axios from "axios";
import * as CONST from "../../includes/Constant";
import { Link } from "react-router-dom";
import Loading from 'react-fullscreen-loading';

import Select from 'react-select';
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import useAuthInfo from "../../../hooks/IsAdmin";
import { S_CURRENT_FINACIAL_MONTH, S_FORMAT_INR_CURRENCY_AND_AMOUNT, SD_CAP_FIRST_LETTER, SD_FY_MONTHS, SD_INVOICE_STATUS, SD_PROJECT_TYPE } from "../../includes/staticData";
import { setGlobalModal } from "../modal/GlobalModal";
import "../../../assets/css/admin.css";
import '../../../invoice.css';
import ViewInvoice from "../modal/invoice/ViewInvoice";
import ViewClient from "../modal/client/ViewClient";


const ReportProjectsDetails = () => {
  const { isAdmin, eDepartmentId } = useAuthInfo();
  const [project, setProject] = useState([]);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [sortColumn, setSortColumn] = useState("inv.id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  /* SEARCH VARIABLES */
  const [financialYears, setFinancialYears] = useState([]);
  const [currentFinancialYears, setCurrentFinancialYears] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [searchParams, setSearchParams] = useState({});
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState("");
  const [departmentData, setDepartmentData] = useState([]);
  const [departments, setDepartments] = useState(null);
  const [userDepartment, setUserDepartment] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [arrProjects, setArrProjects] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  useEffect(() => {
    if (!isAdmin && departmentData.length > 0) {
      const matchedDept = departmentData.find((d) => d.value === eDepartmentId);
      if (matchedDept) {
        setUserDepartment(matchedDept);
        setDepartments(matchedDept);
        setSearchParams((prev) => ({
          ...prev,
          department_id: eDepartmentId
        }));
        fetchClientData(eDepartmentId);
      }
    }
  }, [isAdmin, departmentData]);
  useEffect(() => {
    if (searchParams.financialYear) {
      fetchData();
    }
  }, [currentPage, recordsPerPage, sortColumn, sortOrder, searchParams]);

  useEffect(() => {
    const generateFinancialYears = () => {
      const startYear = 2023; // Start from 2024-2025
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      let financialYearsList = [];
      let endYear = currentMonth >= 4 ? currentYear : currentYear - 1;
      // Loop from latest year to startYear to make latest year appear first
      for (let year = endYear; year >= startYear; year--) {
        financialYearsList.push({
          value: `${year}-${year + 1}`,
          label: `${year}-${year + 1}`,
        });
      }
      setFinancialYears(financialYearsList);
      const currentFinancialYear = `${endYear}-${endYear + 1}`;
      const selectedFY = financialYearsList.find(year => year.value === currentFinancialYear);
      setSearchParams((prev) => ({
        ...prev,
        financialYear: currentFinancialYear,
        month: S_CURRENT_FINACIAL_MONTH().value || "",
      }));
      setSelectedYear(selectedFY);
      setCurrentFinancialYears(selectedFY);
      setSelectedMonth(S_CURRENT_FINACIAL_MONTH());
      setCurrentMonth(S_CURRENT_FINACIAL_MONTH());
    };

    fetchDepartmentData();
    generateFinancialYears();
    fetchAllProjects();
  }, []);

  const fetchDepartmentData = async () => {
    try {
      const departmentResponse = await axios.get(CONST.GET_DEPARTMENT_LIST);
      if (departmentResponse.data.status === 'success') {
        setDepartmentData(departmentResponse.data.data.map(department => ({ value: department.id, label: department.name })));
      }
    } catch (error) {
      toast.error('Error:', error);
    }
  };
  /* GET CLIENT PROJECT */
  const fetchClientProjects = async (clientId) => {
    try {
      const response = await axios.post(CONST.GET_CLIENT_PROJECTS, { cid: clientId });
      if (response.data.status === 'success') {
        setArrProjects(response.data.data.map(project => ({ value: project.id, label: project.name })));
      }
    } catch (error) {
      toast.error('Error fetching projects:', error);

    }
  };
  /* GFET ALL PROJECTS */
  const fetchAllProjects = async () => {
    try {
      const response = await axios.get(CONST.GET_PROJECT_LIST);
      if (response.data) {
        setArrProjects(response.data.data.map(project => ({ value: project.project_id, label: project.project_name })));
      }
    } catch (error) {
      toast.error('Error fetching projects:', error);

    }
  };
  const fetchClientData = async (departmentId) => {
    setLoading(true);
    try {
      const clientsResponse = await axios.get(CONST.GET_ALL_CLIENT, {
        params: departmentId ? { department_id: departmentId } : {},
      });
      //const clientsResponse = await axios.get(CONST.GET_ALL_CLIENT);
      if (clientsResponse.data.status === 'success') {
        setClients(clientsResponse.data.data.map(client => ({
          value: client.id,
          label: client.name,
        })));
      }
    } catch (error) {
      toast.error('Error:', error);
    }
    setLoading(false);
  };

  const fetchData = async () => {
    console.log(searchParams.project_type)
    setLoading(true);
    try {
      const response = await axios.get(CONST.GET_REPORT_PROJECT_LIST, {
        params: {
          page: currentPage,
          per_page: recordsPerPage,
          sort_by: sortColumn,
          sort_order: sortOrder,
          client_id: searchParams.client,
          project_type: searchParams.project_type,
          financial_year: searchParams.financialYear,
          department_id: searchParams.department_id,
          project_id: searchParams.project_id,
          month: selectedMonth?.value,
        }
      });
      if (response.data) {
        setData(response.data.data);
        setTotalRecords(response.data.total);
      } else {
        setData([]);
        setTotalRecords(0);
      }
    } catch (error) {

      setData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const projectTypeOptions = SD_PROJECT_TYPE.map((projectType) => ({
    label: projectType.name,
    value: projectType.code,
  }));

  /* TABLE FUNCTIONS  */

  const columns = [
    {
      dataField: "sr_no",
      text: "#",
      sortable: false,
      formatter: (cell, row) => {
        const sr_no = row?.sr_no || "";
        return (
          <>
            {sr_no}
          </>
        );
      }
    },
    {
      dataField: "project_name",
      text: "Project",
      sortable: true,
      onSort: () => handleSort("project_name"),
      formatter: (cell, row) => {
        const project_name = row?.project_name || "";
        return (
          <>
            {project_name}
          </>
        );
      }
    },
    {
      dataField: "client_name",
      text: "Client",
      sortable: true,
      onSort: () => handleSort("client_name"),
      formatter: (cell, row) => {
        const client_name = row.client_name || "N/A";
        return (
          <>
            <Link to="#" className="action"
              onClick={() =>
                setGlobalModal(
                  ViewClient,
                  {
                    client_id: row.client_id,
                  },
                  {  // Modal Props
                    size: "lg",
                    title: "View Client " + client_name
                  }
                )
              }
            >
              {client_name}
            </Link >

          </>
        );
      }
    },
    ...(isAdmin
      ? [{
        dataField: "department_name",
        text: "Department",
        sort: false,
        formatter: (cell, row) => {
          return row?.department_name || "-"
        }
      }]
      : []
    ),
    {
      dataField: "project_type",
      text: "Project Type",
      sortable: true,
      onSort: () => handleSort("project_type"),
      formatter: (cell, row) => {
        return SD_CAP_FIRST_LETTER(row.project_type || null);
      }
    },
    {
      dataField: "total_paid_inr",
      text: "Payment",
      sortable: true,
      onSort: () => handleSort("total_paid_inr"),
      formatter: (cell, row) => {
        const total_paid_inr = row.total_paid_inr;
        return (
          <>
            {total_paid_inr}
          </>
        );

      }
    },
  ];
  /* HANDLES */
  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);

  };

  const handleSearch = () => {
    
    setSearchParams({
      client: client ? client.value : "",
      project_type: projectType ? projectType.value : "",
      financialYear: selectedYear ? selectedYear.value : "",
      department_id: departments ? departments.value : "",
      project_id: project ? project.value : "",
      month: selectedMonth ? selectedMonth.value : "",
    });
  };
  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await axios.post(CONST.EXPORT_TOP_PAYING_PROJECTS, {
        client_id: searchParams.client,
        project_type: searchParams.project_type,
        year: searchParams.financialYear,
        department_id: searchParams.department_id,
        project_id: searchParams.project_id,
        month: searchParams?.value
      },
        { responseType: 'blob' } // IMPORTANT: this tells axios to handle file as binary
      );

      // Create a blob from the response
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // Create a temporary anchor to trigger download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'top_projects_payment.xlsx'); // custom file name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      setData([]);
    } finally {
      setLoading(false);
    }
  };
  const handleReset = () => {
    setLoading(true);
    setClient(null);
    setProjectType(null);
    setInvoiceDate(null);
    setSelectedYear(currentFinancialYears);
    setCurrentPage(1);
    setInvoiceId("");
    setProject("");
    setSelectedMonth("");
    if (!isAdmin) {
      setSearchParams({
        client: "",
        project_type: "",
        invoice_date: "",
        financialYear: currentFinancialYears ? currentFinancialYears.value : "",
        department_id: departments ? departments.value : "",
        project_id: "",
        month: "",
      });
    } else {
      setDepartments(null);
      setSearchParams({
        client: "",
        project_type: "",
        invoice_date: "",
        financialYear: currentFinancialYears ? currentFinancialYears.value : "",
        department_id: "",
        project_id: "",
        month: "",
      });
    }
    setLoading(false);
  };

  const handleClientChange = (selectedOption) => {
    setClient(selectedOption);
  };
  const handleProjectChange = (selectedOption) => {
    console.log(selectedOption)
    setProject(selectedOption);
  };
  const handleDepartmentChange = (selectedOption) => {
    setDepartments(selectedOption);
    fetchClientData(selectedOption?.value)
  };

  const handleProjectType = (selectedOption) => {
    console.log(selectedOption)
    setProjectType(selectedOption);
  };

  const handleDateChange = (date) => {
    setInvoiceDate(date);
  };
  const handleSort = (column) => {
    const order = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(order);
  };

  const handlePageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  useEffect(() => {
    if (client) {
      fetchClientProjects(client.value);
    }
  }, [client]);
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
  };
  const btnFilters = (
    <>
      <Col className="text-right">
        <Button
          className="mt-1"
          variant="primary" onClick={handleSearch}>
          <i className='bx bx-search-alt'></i> {" "} Search
        </Button>
        <Button
          variant="secondary"
          onClick={handleReset}
          className="ml-2 mt-1"
        >
          <i className='bx bx-x'></i> {" "} Reset
        </Button>
        {
          (data && data.length > 0) ? (
            <Button className="ml-2 mt-1" variant="success" onClick={handleExport}>
              <i class='bx bx-down-arrow-circle'></i> {" "} Export
            </Button>
          ) : ""
        }
      </Col>
    </>
  )

  return (
    <>
      <Loading loading={loading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
      <div className="container-fluid p-0">
        <div className="row mb-2">
          <Col xs={12} sm={9} md={9} lg={10}  >
            <h1 className="h3 mb-2">Projects <strong> Report</strong></h1>
          </Col>

        </div>
        <Row className="mb-2">
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={financialYears}
              placeholder="Financial Year..."
              onChange={handleYearChange}
              value={selectedYear}
            />
          </Col>
          {
            (isAdmin) ? (
              <>
                <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
                  <Select
                    options={departmentData}
                    placeholder="Department..."
                    onChange={handleDepartmentChange}
                    value={departments}
                  />
                </Col>
              </>
            ) : ""
          }

          {/* Client Dropdown */}
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={clients}
              placeholder="Client.."
              onChange={handleClientChange}
              value={client}
            />
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              placeholder="Project..."
              options={arrProjects}
              onChange={handleProjectChange}
              value={project}
            />
          </Col>

          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={projectTypeOptions}
              placeholder="Type..."
              onChange={handleProjectType}
              value={projectType}
            />
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={SD_FY_MONTHS}
              placeholder="Select Month"
              onChange={handleMonthChange}
              value={selectedMonth}
            />
          </Col>

        </Row>
        <Row className='mt-1  mb-2 text-right'>
          {btnFilters}
        </Row>
        <div className="row mb-1">

          <div className="card flex-fill pt-3 pb-2">
            <div className="col-12">
              Showing total {totalRecords}
              <select className="m-2" onChange={handlePageChange} value={recordsPerPage}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select> records
            </div>

            <Table striped bordered hover className="report-table">
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col.dataField}
                      onClick={() => col.sortable && handleSort(col.dataField)}
                      style={{ cursor: col.sortable ? "pointer" : "default" }}
                    >
                      {col.text}
                      {col.sortable && (sortColumn === col.dataField ? (sortOrder === "asc" ? " ▲" : " ▼") : "")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {
                  data.length > 0 ? (data.map((item, index) => (
                    <tr key={index}>
                      {columns.map((col) => (
                        <td key={col.dataField} >
                          {col.formatter ? col.formatter(item[col.dataField], item) : item[col.dataField]}
                        </td>
                      ))}
                    </tr>
                  ))
                  ) : (
                    <tr>
                      <td colSpan={columns.length} className="text-center">
                        No records found.
                      </td>
                    </tr>
                  )
                }

              </tbody>
            </Table>
            <div className="row">
              <div className="col-md-4">
                Showing total {totalRecords}
                <select className="m-2" onChange={handlePageChange} value={recordsPerPage}>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select> records
              </div>
              <div className="col-md-8 text-right">
                <Pagination className="text-right">
                  {[...Array(Math.ceil(totalRecords / recordsPerPage)).keys()].map((num) => (
                    <Pagination.Item key={num + 1} active={num + 1 === currentPage} onClick={() => setCurrentPage(num + 1)}>
                      {num + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportProjectsDetails;
